import React from "react";
import "../styles/Home.css";

function Home() {
  return (
    <div className="home">

      <div className="about">
        <h2><span className="title-span"></span></h2>
      </div>

      <div className="skills">
        <h1> Skills</h1>
        <ol className="list">
          <li className="item">
            <h2> Front-End</h2>
            <span>
              ReactJS, Api Context,Redux, HTML, CSS, npm,
              BootStrap, MaterialUI, StyledComponents
            </span>
          </li>
          <li className="item">
            <h2>Back-End</h2>
            <span>
              NodeJS, ExpressJS, MongoDB, JWT
            </span>
          </li>
          <li className="item">
            <h2>Languages</h2>
            <span>JavaScript , TypeScript, NodeJS</span>
          </li>
          <li className="item">
            <h2>Tools</h2>
            <span>
              GitHub, Gatsby
            </span>
          </li>
        </ol>
      </div>
    </div>
  );
}

export default Home;
